import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Route, Routes } from "react-router-dom";
import DownloadCenterTable from "./table";
import { setDocumentTitle } from "@/lib/documentTitle";
import { Clients } from "@/lib/clients";

const table_name = "d1_download_center";

export default function D1DownloadCenter() {
  const { t, i18n } = useTranslation(["titles"]);

  useEffect(() => {
    setDocumentTitle(
      t("quantilia_download_center", {
        ns: "titles",
        defaultValue: "Quantilia | Download Center",
      }),
    );
  }, [t, i18n.language]);

  return (
    <Routes>
      <Route
        index
        element={
          <DownloadCenterTable client={Clients.D1} table_name={table_name} />
        }
      />
    </Routes>
  );
}
